import { Box } from '@wix/design-system';
import { useSetAtom } from 'jotai';
import React, { useRef } from 'react';
import { scrollerNodeRefAtom } from '../../atoms/session-atoms';
import { VerticalsDrillInContentCards } from './verticals-drill-in-content-cards';
import { VerticalsDrillInTopSection } from './verticals-drill-in-top-section';
export const VerticalsDrillInStandaloneScreen = () => {
  const divRef = useRef(null);
  const setScrollerNode = useSetAtom(scrollerNodeRefAtom);
  setScrollerNode(divRef);
  return /*#__PURE__*/React.createElement(Box, {
    bottom: "0",
    direction: "vertical",
    height: "100%",
    left: "0",
    position: "absolute",
    right: "0",
    top: "0"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: "0 0 auto",
    position: "sticky",
    top: "0",
    width: "100%",
    zIndex: 10
  }, /*#__PURE__*/React.createElement(VerticalsDrillInTopSection, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "1 1 auto",
    minHeight: 0,
    overflow: "auto",
    ref: divRef
  }, /*#__PURE__*/React.createElement(VerticalsDrillInContentCards, null)));
};
//# sourceMappingURL=verticals-drill-in-standalone-screen.js.map